import { CKLayoutGrid } from 'clearkit';
import Helmet from 'react-helmet';
import { Route } from 'react-router-dom';

import { routes } from '~/components/app/appMainRoutes';
import SidebarDrawer from '~/components/SidebarDrawer';
import { useTargetMarket } from '~/components/TargetMarkets/hooks/useTargetMarket';
import history from '~/lib/history';

import CompaniesList from '../../components/TargetMarkets/CompaniesList';
import { Sidebar } from '../../components/TargetMarkets/Sidebar';
import CompanyFromDomain from '../companies/CompanyFromDomain';

type MainPageProps = {
  id?: string;
};

const TargetMarketsPage = () => {
  const MainPage = ({ id }: MainPageProps) => {
    const useTargetMarketProps = useTargetMarket({ id });

    return (
      <CKLayoutGrid className="w-full" gap="0" gridTemplateColumns="auto 1fr">
        <Sidebar {...useTargetMarketProps} />

        <CompaniesList {...useTargetMarketProps} />
      </CKLayoutGrid>
    );
  };

  return (
    <>
      <Helmet>
        <title>Target Markets</title>
      </Helmet>

      <Route
        exact
        path={`${routes.targetMarkets}/list/:id`}
        render={({
          match: {
            params: { id },
          },
        }) => <MainPage id={id} />}
      />

      <Route
        exact
        path={`${routes.targetMarketsDetails}/:domain`}
        render={({
          match: {
            params: { domain },
          },
        }) => (
          <>
            <MainPage />
            <SidebarDrawer
              isVisible
              onToggle={() => history.goBack()}
              size="xxl"
            >
              <CompanyFromDomain domain={domain} />
            </SidebarDrawer>
          </>
        )}
      />

      <Route exact path={routes.targetMarkets}>
        <MainPage />
      </Route>
    </>
  );
};

export default TargetMarketsPage;
